import { nanoid } from '@reduxjs/toolkit';


export const furnitureCategoryOptions = [
  { id: nanoid(), value: 73, label: 'Furniture' },
];

export const itemConditionOptions = [
  { id: nanoid(), value: 'Acceptable', label: 'Acceptable' },
  { id: nanoid(), value: 'Good', label: 'Good' },
  { id: nanoid(), value: 'Like New', label: 'Like New' },
  { id: nanoid(), value: 'New - Original Packaging', label: 'New - Original Packaging' },
  { id: nanoid(), value: 'New - Repackaged', label: 'New - Repackaged' },
  { id: nanoid(), value: 'Parts Only', label: 'Parts Only' },
  { id: nanoid(), value: 'Poor', label: 'Poor' },
  { id: nanoid(), value: 'Refurbished', label: 'Refurbished' },
  { id: nanoid(), value: 'Very Good', label: 'Very Good' },
];

export const approximateAgeOptions = [
  { id: nanoid(), value: 'new', label: 'new' },
  { id: nanoid(), value: '1-2', label: '1-2' },
  { id: nanoid(), value: '3-5', label: '3-5' },
  { id: nanoid(), value: '6-10', label: '6-10' },
  { id: nanoid(), value: '11-20', label: '11-20' },
  { id: nanoid(), value: '21-50', label: '21-50' },
  { id: nanoid(), value: '51-100', label: '51-100' },
  { id: nanoid(), value: '100+', label: '100+' },
];

export const colorOptions = [
  { id: nanoid(), value: 'Beige', label: 'Beige' },
  { id: nanoid(), value: 'Black', label: 'Black' },
  { id: nanoid(), value: 'Blue', label: 'Blue' },
  { id: nanoid(), value: 'Brown', label: 'Brown' },
  { id: nanoid(), value: 'Gold/Brass', label: 'Gold/Brass' },
  { id: nanoid(), value: 'Green', label: 'Green' },
  { id: nanoid(), value: 'Grey', label: 'Grey' },
  { id: nanoid(), value: 'Multi-Colored', label: 'Multi-Colored' },
  { id: nanoid(), value: 'Orange', label: 'Orange' },
  { id: nanoid(), value: 'Red', label: 'Red' },
  { id: nanoid(), value: 'Silver/Chrome', label: 'Silver/Chrome' },
  { id: nanoid(), value: 'Tan', label: 'Tan' },
  { id: nanoid(), value: 'Transparent', label: 'Transparent' },
  { id: nanoid(), value: 'Violet', label: 'Violet' },
  { id: nanoid(), value: 'White', label: 'White' },
  { id: nanoid(), value: 'Yellow', label: 'Yellow' },
];

export const itemPickupDeliveryOptions = [
  { id: nanoid(), value: 'Digital/Online Delivery', label: 'Digital/Online Delivery' },
  { id: nanoid(), value: 'Local Pickup', label: 'Local Pickup' },
  { id: nanoid(), value: 'Local Delivery', label: 'Local Delivery' },
  { id: nanoid(), value: 'Shipping Available', label: 'Shipping Available' },
];

export const sellerTypeOptions = [
  { id: nanoid(), value: 'Individual', label: 'Individual' },
  { id: nanoid(), value: 'Dealer', label: 'Dealer' },
];

export const propertyFeaturesOptions = [
  { id: nanoid(), value: 'Air Conditioning', label: 'Air Conditioning' },
  { id: nanoid(), value: 'Attic', label: 'Attic' },
  { id: nanoid(), value: 'Basement', label: 'Basement' },
  { id: nanoid(), value: 'Fenced-In Yard', label: 'Fenced-In Yard' },
  {
    id: nanoid(),
    value: 'Finished Lower Level',
    label: 'Finished Lower Level',
  },
  { id: nanoid(), value: 'Fireplace', label: 'Fireplace' },
  { id: nanoid(), value: 'Garage', label: 'Garage' },
  { id: nanoid(), value: 'Granite Countertops', label: 'Granite Countertops' },
  { id: nanoid(), value: 'Handicap Accessible', label: 'Handicap Accessible' },
  { id: nanoid(), value: 'Hardwood Floors', label: 'Hardwood Floors' },
  { id: nanoid(), value: 'Heating', label: 'Heating' },
  { id: nanoid(), value: 'Hot Tub', label: 'Hot Tub' },
  { id: nanoid(), value: 'Off-Street Parking', label: 'Off-Street Parking' },
  { id: nanoid(), value: 'Outdoor Deck/Patio', label: 'Outdoor Deck/Patio' },
  { id: nanoid(), value: 'Pool', label: 'Pool' },
  { id: nanoid(), value: 'Security System', label: 'Security System' },
  { id: nanoid(), value: 'Sprinkler System', label: 'Sprinkler System' },
  {
    id: nanoid(),
    value: 'Stainless Appliances',
    label: 'Stainless Appliances',
  },
  { id: nanoid(), value: 'Storage Space', label: 'Storage Space' },
];

export const perPageOptions = [
  { id: nanoid(), value: 12, label: 12 },
  { id: nanoid(), value: 24, label: 24 },
  { id: nanoid(), value: 36, label: 36 },
  { id: nanoid(), value: 48, label: 48 },
  { id: nanoid(), value: 96, label: 96 },
];

export const sortByOptions = [
  { id: nanoid(), value: 'Closest to Me', label: 'Closest to Me' },
  { id: nanoid(), value: 'Recently Posted', label: 'Recently Posted' },
  { id: nanoid(), value: 'Price (low-high)', label: 'Price (low-high)' },
  { id: nanoid(), value: 'Price (high-low)', label: 'Price (high-low)' },
];

export const noResultsMessage = 'No Search Results Found!';
export const endOfListMessage =
  "Looks like you've reached the end of the listings! To find exactly what you're looking for, try refining your search with the filters. Happy searching on FinditZ! ✨";
